
/* eslint-disable */
import { defineComponent, ref, computed, watch } from "vue";
import { Travel } from "@/core/types";
import { FormInstance } from "element-plus";
import { store } from "@/store";
import { focus, dates as dDate } from "@/store/stateless"
import moment from "moment";

export default defineComponent({
  name: 'membersComponent',
  props: {
    members: {
      type: Array,
      required: true,
      default: []
    },
    customer: {
      type: Object,
      required: true,
      default: {} as Travel,
    },
  },
  
  setup(_) {    
    const formMemberDetails = ref<FormInstance>();
    
    const editedTraveller = computed(() => {
      return store.state.personals.customer.travellers_info
    })

    const language = computed(() => {
      return window.localStorage.getItem('language');
    })

    
    const defaultDob = computed(() => {
      return moment().subtract(30,'y').format('YYYY-MM-DD')
    })
    
    const v_dob = (rule, values, callback, index) => {
      const obj = rule.field.split('.')[1] 

      if (index == 0 && calculateAids(editedTraveller.value[obj].dob) < 18 && _.customer.is_family && editedTraveller.value.length > 1) {
        if(editedTraveller.value[obj].dob) {
          callback(new Error( language.value === 'ar' ? 'Parent is not added' : 'Parent is not added'));
        } else {
          callback(new Error( language.value === 'ar' ? 'الرجاء تحديد تاريخ ميلاد صحيح' : 'Please select correct date of birth'));
        }
      } else {
        if(editedTraveller.value[obj].dob === 'Invalid date' || !editedTraveller.value[obj].dob) {
          callback(new Error( language.value === 'ar' ? 'الرجاء تحديد تاريخ ميلاد صحيح' : 'Please select correct date of birth'));
        } else if(moment().diff(editedTraveller.value[obj].dob, 'days') < 0) {
          callback(new Error( language.value === 'ar' ? 'الرجاء تحديد تاريخ ميلاد صحيح' : 'Please select correct date of birth'));
        } else if (index == 0 && calculateAids(editedTraveller.value[obj].dob) < 18 && _.customer.is_family && editedTraveller.value.length > 1) {
          callback(new Error( language.value === 'ar' ? 'Parent is not added' : 'Parent is not added'));
        } else {
          callback();
        }
      }
      
    }

    function calculateAids(dob) {
      if(!dob)
      return 0

      const today = new Date();
      const birthDate = new Date(dob);
      
      let aids = today.getFullYear() - birthDate.getFullYear();
      const month = today.getMonth() - birthDate.getMonth();
      
      if (month < 0 || (month === 0 && today.getDate() < birthDate.getDate())) {
          aids--;
      }
      return aids;
  }

    const maxDob = computed(() => {
      return moment().subtract(18, "years").format("YYYY-MM-DD");
    });

    const getMaxDate = (index: number) => {
      if (index === 0 && _.customer.is_family === true) {
        return maxDob.value;
      } else {
        return dDate.today;
      }
    };

    return {
      focus,
      dDate,
      v_dob,
      defaultDob,
      formMemberDetails,
      maxDob,
      getMaxDate
    }
  }
});
